import React, { useRef, useState, useEffect } from "react";
import { Tooltip } from "@mui/material";

interface EllipsedTooltipProps {
    children: React.ReactNode;
    tooltipContent?: React.ReactNode;
    className?: string;
    maxWidth?: string;
}

const EllipsedTooltip: React.FC<EllipsedTooltipProps> = ({
  children,
  className = "",
  tooltipContent,
  maxWidth,
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isEllipsed, setIsEllipsed] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const checkEllipsis = () => {
      setIsEllipsed(el.scrollWidth > el.clientWidth);
    };

    checkEllipsis();
    window.addEventListener("resize", checkEllipsis);
    return () => window.removeEventListener("resize", checkEllipsis);
  }, [children]);

  const textSpan = (
    <span ref={textRef} style={{maxWidth: maxWidth ? maxWidth : ""}} className={`notification-ellipsis ${className}`}>
      {children}
    </span>
  );

  return isEllipsed ? (
    <Tooltip title={tooltipContent} placement="top" arrow>
      {textSpan}
    </Tooltip>
  ) : (
    textSpan
  );
};

export default EllipsedTooltip;
